import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";
import BuyProject from "./BuyProject";
import "../notes/notes.css";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/projects">
        <Button
          id="back"
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>

      <Grid container justify={"center"} id="topgrid">
        <Grid item xs={12} md={8} sm={12}>
          <Paper className={classes.paper} style={{ color: "black" }}>
            <h1>7th SEM WEB PROJECT</h1>
            <Divider />
            <h2>What topic should you choose ?</h2>
            <ul style={{ textAlign: "left" }}>
              <li>
                The student has to choose a topic which is distinct from others.
              </li>
              <li>
                The topic can be any one of the real world application or a new
                idea.{" "}
              </li>
              <p>
                <b>Note:</b>Having an idea or a topic already in your mind will
                help you to process the execution better. So choose your topic
                wisely on the basis of your knowledge.
              </p>
            </ul>
            <img
              src="data:image/png;base64,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"
              alt=""
            />
            <Divider />
            <h2>What technologies to use?</h2>
            <Divider />
            <h4>Front-end technologies : HTML , CSS , Bootstrap </h4>
            <p>Note : Reactjs and other frameworks can be used</p>
            <h4>Back-end technologies : PHP </h4>
            <p>Note: Nodejs and other backend frameworks can be used</p>
            <br />
            <Divider />
            <h2>Programming languages used</h2>
            <Divider />
            <h3>language : Javascript</h3> <br />
            <Divider />
            <h2>Software to be used</h2>
            <Divider />
            <img
              src="https://cdn.worldvectorlogo.com/logos/visual-studio-code-1.svg"
              alt="vs code"
              style={{ width: "100px" }}
            />
            <h4>
              Editer: Visual Studio Code{" "}
              <a href="https://code.visualstudio.com/">
                https://code.visualstudio.com/
              </a>
            </h4>
            <img
              src="https://cdn.worldvectorlogo.com/logos/xampp.svg"
              alt=" xampp"
              style={{ width: "100px" }}
            />
            <h4>
              PHP server: XAMPP{" "}
              <a href="https://www.apachefriends.org/index.html">
                https://www.apachefriends.org/index.html
              </a>
            </h4>
            <Divider />
            <h2>Procedure</h2>
            <Divider />
            {/* <ul style={{ textAlign: "left" }}>
              <li> Open new project in file in Netbeans IDE.</li>
              <li> Create a java class.</li>
              <li>
                {" "}
                For multiple page layout in the front-end create new jFrame Form
                in the project folder inside the project source folder.
              </li>
              <li>
                {" "}
                Build your layout using Palette and set page properties using
                Properties in the right side of the IDE.
              </li>
              <li>
                {" "}
                If the palette and property is not visible, open it by clicking
                Window > IDE Tools > Palette / Properties in the top-right
                navigation bar.
              </li>
              <li>
                {" "}
                Join the designs using suitable java procedures and make its
                function using proper methods.
              </li>
              <li>
                {" "}
                Connect the SQL to java by importing a MySQL connector to the
                Libraries folder in the main project folder.
              </li>
              <li>
                {" "}
                Use proper SQL queries for the data input, retrieval , update,
                delete and Search.
              </li>
            </ul> */}
              come back later, we are improving viewnotes every day.
            <Divider />
           
          </Paper>
        </Grid>
        <BuyProject />
      </Grid>

    
      <Footer />
    </div>
  );
}
